/* ============
 * Getters for the reports module
 * ============
 *
 * The getters that are available on the
 * reports module.
 */
import { clone } from '@/utils/object';

const getEnrolledReports = state => clone(state.reports);
const getTotalCount = state => clone(state.totalCount);
const getIsLoading = state => clone(state.isReportsLoading);
const getResolvedReports = state => clone(state.resolvedsymptoms);
const getResolvedTotalCount  = state => clone(state.resolvedtotalCount);
const getIsResolvedLoading = state => clone(state.isResolvedsymptomsLoading);
const getSymptomsReports = state => clone(state.symptoms);
const getSymptomsTotalCount  = state => clone(state.symptomstotalCount);
const getIsSymptomsLoading = state => clone(state.issymptomsLoading);
const getallPatients = state => clone(state.allpatients);
const getallPatientsCount = state => clone(state.allpatientstotalCount);
const getIsallPatientsLoading = state => clone(state.isallpatientsLoading);
const getIsPatientByIdIsLoading = state => clone(state.ispatientbyidreportLoading);
const getPatientByIdReportList = state => clone(state.patientbyidreport);
const getIsWeeklyReportLoading = state => clone(state.isweeklyreportLoading);
const getWeeklyReports = state => clone(state.weeklyreports);
const getIsYearlyReportLoading = state => clone(state.isyearlyreportLoading);
const getYearlyReport = state => clone(state.yearlyreports);

export default {
  getEnrolledReports,
  getIsLoading,
  getTotalCount,
  getResolvedReports,
  getResolvedTotalCount,
  getIsResolvedLoading,
  getSymptomsReports,
  getSymptomsTotalCount,
  getIsSymptomsLoading,
  getallPatients,
  getallPatientsCount,
  getIsallPatientsLoading,
  getIsPatientByIdIsLoading,
  getPatientByIdReportList,
  getIsWeeklyReportLoading,
  getWeeklyReports,
  getIsYearlyReportLoading,
  getYearlyReport
};
